import { RequestClientService, ResponseType } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { GetInsightResponse, 
    GetRSInspectionNonConformityResponse, 
    GetRSInspectionOutcomeResponse, 
    GetRightShipInspectionDocumentLinksResponse, 
    RightshipInspectionFleetChartResponse,
    GetUltrasonicReportResponse,
    RightShipInspectionFindingsImagesResponse
} from "../models/rightship-inspection.models";
import { RightShipInspectionRoutes } from "../constants/rightship-inspection.constants";


@autoinject
export class RightShipInspectionsService {

    constructor(private requestClient: RequestClientService) { }

    public getRSInspectionOutcome(inspectionId: number) : Promise<GetRSInspectionOutcomeResponse>{
        return this.requestClient.get(`${RightShipInspectionRoutes.GetRSInspectionOutcome}/${inspectionId}`);
    }

    public getRSInspectionNonConformity(inspectionId: number) : Promise<GetRSInspectionNonConformityResponse>{
        return this.requestClient.get(RightShipInspectionRoutes.GetRSInspectionNonConformity, {rightShipInspectionId: inspectionId});
    }

    public getInsights(inspectionId: number): Promise<GetInsightResponse> {
        return this.requestClient.get(`${RightShipInspectionRoutes.GetInsights}/${inspectionId}`);
    }
    
    public getInspectionThumbnailZipFile(aiRunId: string): Promise<any> {
        return this.requestClient.get<Blob>(`${RightShipInspectionRoutes.GetInspectionThumbnailZipFile}/${aiRunId}`, {}, ResponseType.Blob)
    }
    
    public getRightShipInspectionDocumentLinks(inspectionId: number): Promise<GetRightShipInspectionDocumentLinksResponse> {
        return this.requestClient.get(`${RightShipInspectionRoutes.GetRightShipInspectionDocumentLinks}/${inspectionId}`);
    }

    public getFindingAllDocumentsCount(inspectionId: number): Promise<number> {
        return this.requestClient.get(`${RightShipInspectionRoutes.GetFindingAllDocumentsCount}/${inspectionId}`);
    }

    public getRightshipInspectionFleetBenchMarkingChart(inspectionId: number, preview: boolean): Promise<RightshipInspectionFleetChartResponse> {
        return this.requestClient.get(`${RightShipInspectionRoutes.GetRightshipInspectionFleetBenchMarkingChart}/${inspectionId}`, {preview: preview});
    }

    public getRightShipInspectionFindingsImages(rsInspectionId: number): Promise<RightShipInspectionFindingsImagesResponse> {
        return this.requestClient.get(`${RightShipInspectionRoutes.GetRightShipInspectionFindingsImages}/${rsInspectionId}`);
    }
    
    public getUltrasonicReport(inspectionId: number): Promise<GetUltrasonicReportResponse> {
        return this.requestClient.get(`${RightShipInspectionRoutes.UltrasonicReport}/${inspectionId}`);
    }
    
}
